module.exports = __webpack_public_path__ + "img/4.18957479.jpg";